export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (filter, libraries, library, recordings) {pug_mixins["options"] = pug_interp = function(available, selected){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate (available)
;(function(){
  var $$obj = (available);
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var v = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var v = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

};


























pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (recordings) {
pug_html = pug_html + "\u003Cdiv class=\"card\"\u003E";
if (libraries && libraries.length > 1) {
pug_html = pug_html + "\u003Cdiv class=\"controls\"\u003E\u003Clabel\u003ELibrary:\u003C\u002Flabel\u003E\u003Cselect class=\"library\" name=\"library\"\u003E";
pug_mixins["options"](libraries, library);
pug_html = pug_html + "\u003C\u002Fselect\u003E\u003Clabel\u003EFilter:\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"filter\""+" name=\"filter\""+pug_attr("value", filter, true, true)) + "\u003E\u003Cbutton class=\"autoplay\"\u003EAutoplay\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E";
}
pug_html = pug_html + "\u003Cul class=\"tracks\"\u003E";
// iterate recordings
;(function(){
  var $$obj = recordings;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var track = $$obj[index];
pug_html = pug_html + "\u003Cli" + (pug_attr("class", pug_classes([{inLibrary: track.inLibrary, inactive: ! track.active}], [true]), false, true)) + "\u003E\u003Ca" + (pug_attr("class", pug_classes(["track track-" + track.id], [true]), false, true)+pug_attr("href", `#/player/${track.id}`, true, true)+pug_attr("data-track", track.id, true, true)+pug_attr("data-idx", index, true, true)) + "\u003E\u003Cdiv class=\"genre\"\u003E\u003Cdiv class=\"long\"\u003E" + (pug_escape(null == (pug_interp = track.genre) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"short\"\u003E" + (pug_escape(null == (pug_interp = track.shortGenre) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"artist\"\u003E" + (pug_escape(null == (pug_interp = track.artist) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"date\"\u003E\u003Cdiv class=\"long\"\u003E" + (pug_escape(null == (pug_interp = track.recording_date) ? "" : pug_interp)) + "&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"short\"\u003E" + (pug_escape(null == (pug_interp = track.shortDate) ? "" : pug_interp)) + "&nbsp;\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = track.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var track = $$obj[index];
pug_html = pug_html + "\u003Cli" + (pug_attr("class", pug_classes([{inLibrary: track.inLibrary, inactive: ! track.active}], [true]), false, true)) + "\u003E\u003Ca" + (pug_attr("class", pug_classes(["track track-" + track.id], [true]), false, true)+pug_attr("href", `#/player/${track.id}`, true, true)+pug_attr("data-track", track.id, true, true)+pug_attr("data-idx", index, true, true)) + "\u003E\u003Cdiv class=\"genre\"\u003E\u003Cdiv class=\"long\"\u003E" + (pug_escape(null == (pug_interp = track.genre) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"short\"\u003E" + (pug_escape(null == (pug_interp = track.shortGenre) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"artist\"\u003E" + (pug_escape(null == (pug_interp = track.artist) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"date\"\u003E\u003Cdiv class=\"long\"\u003E" + (pug_escape(null == (pug_interp = track.recording_date) ? "" : pug_interp)) + "&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"short\"\u003E" + (pug_escape(null == (pug_interp = track.shortDate) ? "" : pug_interp)) + "&nbsp;\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = track.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cli class=\"infinite\"\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"filter" in locals_for_with?locals_for_with.filter:typeof filter!=="undefined"?filter:undefined,"libraries" in locals_for_with?locals_for_with.libraries:typeof libraries!=="undefined"?libraries:undefined,"library" in locals_for_with?locals_for_with.library:typeof library!=="undefined"?library:undefined,"recordings" in locals_for_with?locals_for_with.recordings:typeof recordings!=="undefined"?recordings:undefined));;return pug_html;}